module.exports = __webpack_public_path__ + "img/galaxy-buds-2-copy@2x.e6d03026.png";